const TVSeries = () => {
    return (
        <div>
            <h1>TV Series Page</h1>
            <p>Explore a variety of TV series here.</p>
        </div>
    );
};

export default TVSeries;